var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiThumbsUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 8.41683C1.33301 7.72647 1.89265 7.16683 2.58301 7.16683C3.27336 7.16683 3.83301 7.72647 3.83301 8.41683V13.4168C3.83301 14.1072 3.27336 14.6668 2.58301 14.6668C1.89265 14.6668 1.33301 14.1072 1.33301 13.4168V8.41683Z",
    fill: "#252919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 8.27794V12.8034C4.66634 13.4347 5.02301 14.0118 5.58765 14.2942L5.62919 14.3149C6.09204 14.5463 6.60242 14.6668 7.1199 14.6668H11.6333C12.4278 14.6668 13.1118 14.1061 13.2676 13.327L14.2676 8.32702C14.4739 7.2957 13.6851 6.3335 12.6333 6.3335H9.66634V3.00016C9.66634 2.07969 8.92015 1.3335 7.99968 1.3335C7.53944 1.3335 7.16634 1.70659 7.16634 2.16683V2.72238C7.16634 3.44362 6.93242 4.1454 6.49967 4.72238L5.33301 6.27794C4.90027 6.85493 4.66634 7.55671 4.66634 8.27794Z",
    fill: "#252919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiThumbsUp);
export default __webpack_public_path__ + "static/media/ai-thumbs-up.55628aee169a6959205606fa55b234e4.svg";
export { ForwardRef as ReactComponent };